
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCautionEmpty as ObiCautionEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-caution-empty.js';
 
 
 

 
 export const ObiCautionEmpty = createComponent({
   react: React,
   tagName: 'obi-caution-empty',
   elementClass: ObiCautionEmptyElement,
   events: {
     
   }
  });
 
 